import {createContext} from "react"

export const menuIsOpenContext = createContext({
  state: false,
  update: (state: boolean) => {},
})